import styled, { css } from 'styled-components';
import { Link as ReactLink } from 'react-router-dom';
import settings from '../../services/settings.json';

const { light, primary } = settings.color;

const ButtonBaseStyle = css`
    cursor: pointer;
    background-color: ${({ backgroundcolor }) => backgroundcolor};
    border-radius: ${({ borderRadius }) => borderRadius};
    border: ${({ border }) => border};
    box-shadow: ${({ shadow }) => shadow};
    color: ${({ color }) => color};
    display:  ${({ display }) => display};
    font-size:  ${({ fontSize }) => fontSize};
    font-weight: ${({ fontWeight }) => fontWeight};
    height: ${({ height }) => height};
    line-height: ${({ lineheight }) => lineheight};
    margin: ${({ margin }) => margin};
    padding: ${({ padding }) => padding};
    text-align: center;
    text-transform: ${({ uppercase }) => uppercase};
    transition: .3s;
    width: ${({ width }) => width};
	position: ${({ position }) => position};
	top: ${({ top }) => top};
	bottom: ${({ bottom }) => bottom};
	left: ${({ left }) => left};
	right: ${({ right }) => right};
    align-items: center;
    justify-content: center;

    &:disabled, button[disabled] {
        opacity: .6;
        cursor: not-allowed;
    }

    &:hover {
        transition: .3s;
        opacity: .6;
        font-style: normal;
        text-decoration: none;
        color: ${({ color }) => color};
    }
    
    &:focus {
        outline: 0;
    }

    ${({ theme }) => theme === 'naked' && `
        background-color: transparent;
        border: 1px solid ${primary};
        color: ${primary};
    `}

    ${({ theme }) => theme === 'inverse' && `
        background-color: ${light};
        border: none;
        color: ${primary};
    `}
`;

export const Button = styled.button`
    ${ButtonBaseStyle}
`;

export const Link = styled(ReactLink)`
    ${ButtonBaseStyle}
`;
